/**
 * Centralizes the inline role checks that used to be sprinkled across
 * Header / AdminPage / OrganizationPage. All values are derived from
 * `useMe()` + `useActiveOrg()`; this hook adds no new state.
 *
 * `isOrgAdmin` and `isOrgOwner` are scoped to the **active** org. If
 * the user wants to admin a different org, they switch first via the
 * org switcher.
 */

import { useActiveOrg } from './activeOrg';
import { useMe } from './auth';

export interface Roles {
  isSiteAdmin: boolean;
  isOrgAdmin: boolean;
  isOrgOwner: boolean;
}

export function useRoles(): Roles {
  const me = useMe();
  const activeOrg = useActiveOrg(me.data?.organizations);
  const user = me.data?.user;
  const role = activeOrg?.role;
  return {
    isSiteAdmin: Boolean(user?.is_superuser || me.data?.system_roles.includes('admin')),
    isOrgAdmin: role === 'owner' || role === 'admin',
    isOrgOwner: role === 'owner',
  };
}
